import React, { useState } from "react";
import "../../../assets/css/admin/Withdrawals.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

// ── Dummy Data ────────────────────────────────────────────────────────────────
const SEED_WITHDRAWALS = [
  {
    id: "WD-001",
    mentor: "Ali Khan",
    avatar: "AK",
    amount: 5000,
    status: "Pending",
    date: "2025-01-10",
    method: "JazzCash",
    account: "03001234567",
  },
  {
    id: "WD-002",
    mentor: "Sara Ahmed",
    avatar: "SA",
    amount: 8500,
    status: "Pending",
    date: "2025-01-10",
    method: "EasyPaisa",
    account: "03111234567",
  },
  {
    id: "WD-003",
    mentor: "Bilal Hassan",
    avatar: "BH",
    amount: 12000,
    status: "Pending",
    date: "2025-01-09",
    method: "Bank",
    account: "PK36SCBL0000001123456702",
  },
  {
    id: "WD-004",
    mentor: "Fatima Noor",
    avatar: "FN",
    amount: 3500,
    status: "Pending",
    date: "2025-01-09",
    method: "JazzCash",
    account: "03211234567",
  },
  {
    id: "WD-005",
    mentor: "Kamran Siddiqui",
    avatar: "KS",
    amount: 6000,
    status: "Pending",
    date: "2025-01-08",
    method: "EasyPaisa",
    account: "03311234567",
  },
  {
    id: "WD-006",
    mentor: "Ayesha Rahman",
    avatar: "AR",
    amount: 9500,
    status: "Approved",
    date: "2025-01-07",
    method: "Bank",
    account: "PK36SCBL0000001123456703",
  },
  {
    id: "WD-007",
    mentor: "Hassan Malik",
    avatar: "HM",
    amount: 7200,
    status: "Approved",
    date: "2025-01-06",
    method: "JazzCash",
    account: "03411234567",
  },
  {
    id: "WD-008",
    mentor: "Zainab Yusuf",
    avatar: "ZY",
    amount: 4100,
    status: "Rejected",
    date: "2025-01-05",
    method: "EasyPaisa",
    account: "03511234567",
  },
];

// ── Status config ─────────────────────────────────────────────────────────────
const STATUS_CLASS = {
  Pending: "wd-badge--pending",
  Approved: "wd-badge--approved",
  Rejected: "wd-badge--rejected",
};

// ── Format helpers ────────────────────────────────────────────────────────────
const fmt = (n) => `Rs ${n.toLocaleString()}`;

// ── Icons ─────────────────────────────────────────────────────────────────────
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconX = () => (
  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 6V12L16 14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconWallet = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <path
      d="M20 7H4C2.895 7 2 7.895 2 9V19C2 20.105 2.895 21 4 21H20C21.105 21 22 20.105 22 19V9C22 7.895 21.105 7 20 7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3L20 7H4L8 3H16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="17" cy="14" r="1.5" fill="currentColor" />
  </svg>
);
const IconApproved = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <path
      d="M22 11.08V12C21.999 14.156 21.3 16.255 20.009 17.982C18.718 19.709 16.903 20.972 14.835 21.584C12.767 22.195 10.557 22.122 8.534 21.375C6.512 20.627 4.785 19.246 3.611 17.437C2.437 15.628 1.88 13.488 2.022 11.336C2.164 9.185 2.997 7.136 4.398 5.497C5.799 3.858 7.693 2.715 9.796 2.24C11.9 1.765 14.1 1.982 16.07 2.86"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 4L12 14.01L9 11.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconRejected = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M4.93 4.93L19.07 19.07"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const IconFilter = () => (
  <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
    <path
      d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ── Main Component ────────────────────────────────────────────────────────────
const Withdrawals = () => {
  const [requests, setRequests] = useState(SEED_WITHDRAWALS);
  const [filterStatus, setFilter] = useState("All");
  const [confirm, setConfirm] = useState(null); // { id, action }
  const [toast, setToast] = useState(null); // { msg, type }

  // ── Derived stats ──────────────────────────────────────────────────────────
  const pendingList = requests.filter((r) => r.status === "Pending");
  const approvedList = requests.filter((r) => r.status === "Approved");
  const rejectedList = requests.filter((r) => r.status === "Rejected");
  const pendingAmount = pendingList.reduce((s, r) => s + r.amount, 0);
  const totalAmount = requests.reduce((s, r) => s + r.amount, 0);

  // ── Filtered view ──────────────────────────────────────────────────────────
  const visible =
    filterStatus === "All"
      ? requests
      : requests.filter((r) => r.status === filterStatus);

  // ── Action handlers ────────────────────────────────────────────────────────
  const openConfirm = (id, action) => setConfirm({ id, action });
  const cancelConfirm = () => setConfirm(null);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleConfirm = () => {
    const { id, action } = confirm;
    const mentor = requests.find((r) => r.id === id)?.mentor;
    setRequests((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, status: action === "approve" ? "Approved" : "Rejected" }
          : r,
      ),
    );
    setConfirm(null);
    showToast(
      action === "approve"
        ? `✓ ${mentor}'s withdrawal approved successfully.`
        : `✗ ${mentor}'s withdrawal has been rejected.`,
      action === "approve" ? "success" : "error",
    );
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <AdminLayout>
      <div className="wd-page">
        {/* ── Page Header ── */}
        <div className="wd-topbar">
          <div>
            <h2 className="wd-page-title">Withdrawal Management</h2>
            <p className="wd-page-desc">
              Review and process mentor payout requests
            </p>
          </div>
        </div>

        {/* ── KPI Cards — same structure as adm-stat-card ── */}
        <div className="wd-stats-grid">
          <div className="wd-stat-card">
            <div className="wd-stat-card-top">
              <div className="wd-stat-icon wd-stat-icon--pending">
                <IconClock />
              </div>
              <span className="wd-delta wd-delta--yellow">
                {pendingList.length} new
              </span>
            </div>
            <div className="wd-stat-number">{pendingList.length}</div>
            <div className="wd-stat-title">Pending Requests</div>
          </div>

          <div className="wd-stat-card">
            <div className="wd-stat-card-top">
              <div className="wd-stat-icon wd-stat-icon--amount">
                <IconWallet />
              </div>
              <span className="wd-delta wd-delta--orange">awaiting</span>
            </div>
            <div className="wd-stat-number wd-stat-number--sm">
              {fmt(pendingAmount)}
            </div>
            <div className="wd-stat-title">Total Pending Amount</div>
          </div>

          <div className="wd-stat-card">
            <div className="wd-stat-card-top">
              <div className="wd-stat-icon wd-stat-icon--approved">
                <IconApproved />
              </div>
              <span className="wd-delta wd-delta--green">
                {approvedList.length} paid
              </span>
            </div>
            <div className="wd-stat-number">{approvedList.length}</div>
            <div className="wd-stat-title">Approved</div>
          </div>

          <div className="wd-stat-card">
            <div className="wd-stat-card-top">
              <div className="wd-stat-icon wd-stat-icon--rejected">
                <IconRejected />
              </div>
              <span className="wd-delta wd-delta--red">
                {rejectedList.length} denied
              </span>
            </div>
            <div className="wd-stat-number">{rejectedList.length}</div>
            <div className="wd-stat-title">Rejected</div>
          </div>
        </div>

        {/* ── Table Card ── */}
        <div className="wd-card">
          <div className="wd-card-header">
            <div className="wd-card-header-left">
              <h3 className="wd-card-title">Withdrawal Requests</h3>
              <span className="wd-table-count">{visible.length} entries</span>
            </div>
            {/* Filter tabs */}
            <div className="wd-filter-tabs">
              <IconFilter />
              {["All", "Pending", "Approved", "Rejected"].map((s) => (
                <button
                  key={s}
                  className={`wd-filter-btn${filterStatus === s ? " wd-filter-btn--active" : ""}`}
                  onClick={() => setFilter(s)}
                >
                  {s}
                  <span className="wd-filter-count">
                    {s === "All"
                      ? requests.length
                      : s === "Pending"
                        ? pendingList.length
                        : s === "Approved"
                          ? approvedList.length
                          : rejectedList.length}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="wd-table-wrapper">
            <table className="wd-table">
              <thead>
                <tr>
                  <th>Request ID</th>
                  <th>Mentor</th>
                  <th>Amount</th>
                  <th>Method</th>
                  <th className="wd-th--center">Status</th>
                  <th>Request Date</th>
                  <th className="wd-th--center">Action</th>
                </tr>
              </thead>
              <tbody>
                {visible.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <span className="wd-id-badge">{row.id}</span>
                    </td>
                    <td>
                      <div className="wd-mentor-cell">
                        <div className="wd-mentor-avatar">{row.avatar}</div>
                        <span className="wd-mentor-name">{row.mentor}</span>
                      </div>
                    </td>
                    <td>
                      <span className="wd-amount">{fmt(row.amount)}</span>
                    </td>
                    <td>
                      <span className="wd-method">{row.method}</span>
                    </td>
                    <td className="wd-td--center">
                      <span className={`wd-badge ${STATUS_CLASS[row.status]}`}>
                        {row.status}
                      </span>
                    </td>
                    <td className="wd-date">{row.date}</td>
                    <td className="wd-td--center">
                      {row.status === "Pending" ? (
                        <div className="wd-actions">
                          <button
                            className="wd-action-btn wd-action-btn--approve"
                            onClick={() => openConfirm(row.id, "approve")}
                          >
                            <IconCheck /> Approve
                          </button>
                          <button
                            className="wd-action-btn wd-action-btn--reject"
                            onClick={() => openConfirm(row.id, "reject")}
                          >
                            <IconX /> Reject
                          </button>
                        </div>
                      ) : (
                        <span className="wd-action-done">
                          {row.status === "Approved"
                            ? "✓ Processed"
                            : "✗ Declined"}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}

                {visible.length === 0 && (
                  <tr>
                    <td colSpan={7} className="wd-empty">
                      <div className="wd-empty-inner">
                        <IconWallet />
                        <p>No {filterStatus.toLowerCase()} requests found.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Confirm Modal ── */}
        {confirm && (
          <div
            className="wd-modal-overlay"
            onClick={(e) => e.target === e.currentTarget && cancelConfirm()}
          >
            <div className="wd-modal" role="alertdialog" aria-modal="true">
              <div className="wd-modal-header">
                <div
                  className={`wd-modal-icon ${confirm.action === "approve" ? "wd-modal-icon--approve" : "wd-modal-icon--reject"}`}
                >
                  {confirm.action === "approve" ? <IconCheck /> : <IconX />}
                </div>
                <h3 className="wd-modal-title">
                  {confirm.action === "approve"
                    ? "Approve Withdrawal"
                    : "Reject Withdrawal"}
                </h3>
                <button
                  className="wd-modal-close"
                  onClick={cancelConfirm}
                  aria-label="Close"
                >
                  <IconX />
                </button>
              </div>
              <div className="wd-modal-body">
                {(() => {
                  const row = requests.find((r) => r.id === confirm.id);
                  return (
                    <>
                      <div className="wd-modal-detail">
                        <div className="wd-modal-mentor">
                          <div className="wd-mentor-avatar wd-mentor-avatar--lg">
                            {row.avatar}
                          </div>
                          <div>
                            <p className="wd-modal-mentor-name">{row.mentor}</p>
                            <p className="wd-modal-mentor-sub">
                              {row.method} · {row.account}
                            </p>
                          </div>
                        </div>
                        <div className="wd-modal-amount">{fmt(row.amount)}</div>
                      </div>
                      <p className="wd-modal-msg">
                        {confirm.action === "approve"
                          ? `Are you sure you want to approve this withdrawal of ${fmt(row.amount)} for ${row.mentor}? The amount will be transferred to their account.`
                          : `Are you sure you want to reject this withdrawal request from ${row.mentor}? They will be notified of the decision.`}
                      </p>
                    </>
                  );
                })()}
              </div>
              <div className="wd-modal-footer">
                <button
                  className="wd-btn wd-btn--ghost"
                  onClick={cancelConfirm}
                >
                  Cancel
                </button>
                {confirm.action === "approve" ? (
                  <button
                    className="wd-btn wd-btn--approve"
                    onClick={handleConfirm}
                  >
                    <IconCheck /> Yes, Approve
                  </button>
                ) : (
                  <button
                    className="wd-btn wd-btn--reject"
                    onClick={handleConfirm}
                  >
                    <IconX /> Yes, Reject
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div className={`wd-toast wd-toast--${toast.type}`}>{toast.msg}</div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Withdrawals;
